import { render, staticRenderFns } from "./MakeCopyModal.vue?vue&type=template&id=d5605a56&"
import script from "./MakeCopyModal.vue?vue&type=script&lang=ts&"
export * from "./MakeCopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports